// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_link-one_btn-primary__1zPl2","one":"_link-one_one__M7lpH"};